var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-33.09 0 523.028 523.028",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-305.835 767.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "M491.58-419.079l2.708,1.387a7.947,7.947,0,0,1,3.425,10.627L439.864-292.639a7.748,7.748,0,0,0,.248,7.627l17.041,28.88a7.842,7.842,0,0,1-.753,9.147,7.675,7.675,0,0,1-8.82,2.253,375.78,375.78,0,0,1-67.052-34.64,7.812,7.812,0,0,1-3.387-8.52,7.761,7.761,0,0,1,6.9-6l32.881-3.04a7.625,7.625,0,0,0,6.267-4.28l57.849-114.413a7.824,7.824,0,0,1,10.543-3.453",
    fill: "#465da9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M674-626.092l-59.856-30.76-60.878-31.28a7.775,7.775,0,0,0-10.048,2.613l-59.995,89.267c-.048.08-.091.133-.143.213q-60.894,84.68-30.6,150.586c.081.173.156.32.249.493a105.95,105.95,0,0,0,32.144,35.56,5.892,5.892,0,0,0,.964.587l3.577,1.84a6.04,6.04,0,0,0,1.037.44q24.072,8.26,47.432,5.333c.192-.027.356-.053.545-.093q70.7-14.02,102.893-113.44c.028-.093.051-.16.081-.24l36.405-101.4a7.884,7.884,0,0,0-3.812-9.72",
    fill: "#f9b317",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "M476.4-586.4q57.63,13.12,103.709-11.933c26.1-16.893,58.127-23.427,97.122-16.413l.581-1.627a7.882,7.882,0,0,0-3.812-9.72l-59.857-30.76-60.88-31.28a7.778,7.778,0,0,0-10.049,2.613l-59.993,89.267-.141.213c-2.327,3.227-4.553,6.453-6.68,9.64",
    fill: "#465da9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M623.825-505.612q-48.436,92.5-120.473,94.226H502.8c-1.439-.067-2.873-.173-4.305-.307a98.615,98.615,0,0,1-17.795-3.267c-1.593-.44-3.181-.933-4.767-1.453,1.26,1.093,2.552,2.16,3.877,3.213,1.639,1.293,3.327,2.573,5.064,3.8l.964.587,3.576,1.84,1.036.44c2.016.693,4.027,1.32,6.035,1.893a102.728,102.728,0,0,0,41.4,3.44c.193-.027.355-.053.544-.093q70.7-14.02,102.894-113.44l.081-.24,21.467-59.787-38.927,68.933-.117.213",
    fill: "#db8e19",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "M483.109-533.8a7.836,7.836,0,0,1,9.016,6.493,7.9,7.9,0,0,1-6.445,9.093,7.857,7.857,0,0,1-9.019-6.507,7.886,7.886,0,0,1,6.448-9.08",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M507.053-475.332a7.836,7.836,0,0,1,9.016,6.493,7.9,7.9,0,0,1-6.447,9.093,7.845,7.845,0,0,1-9.016-6.493,7.891,7.891,0,0,1,6.447-9.093",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "M554.488-505.719a7.848,7.848,0,0,1,9.019,6.507,7.9,7.9,0,0,1-6.448,9.093,7.859,7.859,0,0,1-9.02-6.507,7.9,7.9,0,0,1,6.449-9.093",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M582.852-536.105a3.146,3.146,0,0,1,3.608,2.6,3.152,3.152,0,0,1-2.58,3.64,3.136,3.136,0,0,1-3.609-2.6,3.166,3.166,0,0,1,2.581-3.64",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M622.045-577.919a6.278,6.278,0,0,1,7.212,5.2,6.325,6.325,0,0,1-5.156,7.28,6.279,6.279,0,0,1-7.213-5.2,6.319,6.319,0,0,1,5.157-7.28",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M534.667-558.465a4.713,4.713,0,0,1,5.411,3.907,4.748,4.748,0,0,1-3.868,5.453,4.713,4.713,0,0,1-5.412-3.907,4.733,4.733,0,0,1,3.869-5.453",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M334.73-446.452,362.548-426.4a5.788,5.788,0,0,1,1.321,8.013l-19.889,28.04a5.677,5.677,0,0,1-7.947,1.333l-27.819-20.053a5.789,5.789,0,0,1-1.323-8.013l19.889-28.04a5.679,5.679,0,0,1,7.948-1.333",
    fill: "#43bb4e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M348.638-436.426q.064,25.56-26.511,37.387l13.907,10.027a5.677,5.677,0,0,0,7.947-1.333l19.887-28.04a5.781,5.781,0,0,0-1.321-8.013l-13.908-10.027",
    fill: "#32a940",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "M713.48-697.9a54.453,54.453,0,0,1,23.973-35.96,3.961,3.961,0,0,0,1.761-4.147,3.932,3.932,0,0,0-3.184-3.173,53.955,53.955,0,0,1-35.672-24.16,3.883,3.883,0,0,0-4.113-1.773,3.909,3.909,0,0,0-3.141,3.2,54.443,54.443,0,0,1-23.976,35.96,3.961,3.961,0,0,0-1.759,4.147,3.929,3.929,0,0,0,3.184,3.173,53.967,53.967,0,0,1,35.672,24.173,3.9,3.9,0,0,0,4.113,1.773,3.943,3.943,0,0,0,3.141-3.213",
    fill: "#5b7fc9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M715.708-749.531q2.58,27.68-24.833,37.24a54.22,54.22,0,0,1,15.351,15.827,3.9,3.9,0,0,0,4.113,1.773,3.943,3.943,0,0,0,3.141-3.213,54.453,54.453,0,0,1,23.973-35.96,3.96,3.96,0,0,0,1.761-4.147,3.932,3.932,0,0,0-3.184-3.173,53.546,53.546,0,0,1-20.323-8.347",
    fill: "#4267ba",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M604.531-250.293a54.448,54.448,0,0,1,23.973-35.96,3.96,3.96,0,0,0,1.76-4.147,3.928,3.928,0,0,0-3.183-3.173,54,54,0,0,1-35.672-24.16,3.883,3.883,0,0,0-4.113-1.773,3.908,3.908,0,0,0-3.141,3.2,54.442,54.442,0,0,1-23.976,35.96,3.957,3.957,0,0,0-1.759,4.147,3.926,3.926,0,0,0,3.183,3.173,53.973,53.973,0,0,1,35.673,24.173,3.9,3.9,0,0,0,4.113,1.773,3.943,3.943,0,0,0,3.141-3.213",
    fill: "#5b7fc9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M606.759-301.919q2.58,27.68-24.833,37.24a54.076,54.076,0,0,1,15.351,15.827,3.9,3.9,0,0,0,4.113,1.773,3.943,3.943,0,0,0,3.141-3.213,54.448,54.448,0,0,1,23.973-35.96,3.96,3.96,0,0,0,1.76-4.147,3.928,3.928,0,0,0-3.183-3.173,53.546,53.546,0,0,1-20.323-8.347",
    fill: "#4267ba",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "M351.77-615.372a5.127,5.127,0,0,1,3.111-6.52,5.069,5.069,0,0,1,6.467,3.147l7.373,21.213a5.126,5.126,0,0,1-3.112,6.52,5.069,5.069,0,0,1-6.467-3.147l-7.372-21.213",
    fill: "#f0393c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M365.852-574.839a5.125,5.125,0,0,1,3.111-6.52,5.064,5.064,0,0,1,6.468,3.133L382.8-557a5.139,5.139,0,0,1-3.113,6.52,5.07,5.07,0,0,1-6.467-3.147l-7.371-21.213",
    fill: "#f0393c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M338.338-570.545a5.063,5.063,0,0,1-6.467-3.133,5.127,5.127,0,0,1,3.112-6.52l21.045-7.44a5.072,5.072,0,0,1,6.468,3.147,5.129,5.129,0,0,1-3.112,6.52l-21.047,7.427",
    fill: "#f0393c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M378.542-584.745a5.064,5.064,0,0,1-6.467-3.133,5.128,5.128,0,0,1,3.112-6.52l21.047-7.427a5.063,5.063,0,0,1,6.467,3.133,5.129,5.129,0,0,1-3.112,6.52l-21.047,7.427",
    fill: "#f0393c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M718.849-380.439a4.787,4.787,0,0,1,4.033-5.427,4.764,4.764,0,0,1,5.376,4.067l2.948,20.84a4.781,4.781,0,0,1-4.033,5.413,4.753,4.753,0,0,1-5.375-4.067l-2.949-20.827",
    fill: "#43bb4e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M724.482-340.639a4.783,4.783,0,0,1,4.033-5.413,4.753,4.753,0,0,1,5.375,4.067l2.949,20.827a4.787,4.787,0,0,1-4.033,5.427,4.755,4.755,0,0,1-5.376-4.067l-2.948-20.84",
    fill: "#43bb4e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "M698.434-341.733a4.756,4.756,0,0,1-5.376-4.067,4.784,4.784,0,0,1,4.035-5.413l20.672-2.973a4.753,4.753,0,0,1,5.375,4.067,4.783,4.783,0,0,1-4.033,5.413l-20.672,2.973",
    fill: "#43bb4e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M737.925-347.413a4.753,4.753,0,0,1-5.376-4.067,4.781,4.781,0,0,1,4.035-5.413l20.669-2.973a4.755,4.755,0,0,1,5.376,4.067,4.782,4.782,0,0,1-4.033,5.413l-20.671,2.973",
    fill: "#43bb4e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "M716.853-533.025a20.5,20.5,0,0,1,23.56,16.987,20.627,20.627,0,0,1-16.844,23.747,20.5,20.5,0,0,1-23.56-16.987,20.626,20.626,0,0,1,16.844-23.747",
    fill: "#f0393c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M483.448-763.065a20.5,20.5,0,0,1,23.559,16.987,20.626,20.626,0,0,1-16.844,23.747A20.5,20.5,0,0,1,466.6-739.3a20.64,20.64,0,0,1,16.845-23.76",
    fill: "#f9b317",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinks);
export default __webpack_public_path__ + "static/media/drinks.0455a394da32fe7f29c621c5900d34af.svg";
export { ForwardRef as ReactComponent };